import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import UserTable from "../components/UserTable";
import {
  blockUnblockedUser,
  deleteUser,
  fetchUsers,
} from "../redux/action/userAction";
import Loader from "../components/other/Loader";
import { setSelectedUser } from "../redux/reducers/userReducer";
import { Country, City } from "country-state-city";
import { downloadCSV } from "../utils/pip";

const Users = () => {
  const dispatch = useDispatch();

  const { isToggle } = useSelector((state) => state.authReducer);
  const { isLoading, selectedUser, userList } = useSelector(
    (state) => state.userReducer
  );
  const [isBlocked, setIsBlocked] = useState(selectedUser?.is_blocked);
  const [filteredUser, setFilteredUser] = useState(userList);
  const [filterCriteria, setFilterCriteria] = useState({
    country: "",
    city: "",
    gender: "",
    status: "",
    searchQuery: "",
  });

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const allCountries = Country.getAllCountries();
    setCountries(allCountries);
  }, []);

  const genderOptions = [
    { key: "Men", select: false },
    { key: "CisMan", select: false },
    { key: "IntersexMan", select: false },
    { key: "TransMan", select: false },
    { key: "Transmasculine", select: false },
    { key: "Woman", select: false },
    { key: "CisWoman", select: false },
    { key: "IntersexWoman", select: false },
    { key: "TransWoman", select: false },
    { key: "Transfeminine", select: false },
    { key: "BeyondBinary", select: false },
    { key: "Agender", select: false },
    { key: "Androgyne", select: false },
    { key: "Bigender", select: false },
    { key: "Genderfluid", select: false },
    { key: "GenderQuestioning", select: false },
    { key: "Genderqueer", select: false },
    { key: "Imtersex", select: false },
    { key: "Neutrois", select: false },
    { key: "Nonbinary", select: false },
    { key: "Pangender", select: false },
    { key: "TransPerson", select: false },
    { key: "TwoSpirit", select: false },
    { key: "NotListed", select: false },
  ];

  useEffect(() => {
    setIsBlocked(selectedUser?.is_blocked);
  }, [selectedUser]);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    const filtered = userList.filter((item) => {
      const matchesCountry =
        !filterCriteria.country || item.country === filterCriteria.country;
      const matchesCity =
        !filterCriteria.city || item.city === filterCriteria.city; // Show all cities if no specific city is selected
      const matchesGender =
        !filterCriteria.gender || item.gender === filterCriteria.gender;
      const matchesStatus =
        !filterCriteria.status || item.is_blocked == filterCriteria.status;
      const matchesSearch =
        !filterCriteria.searchQuery ||
        item.name
          .toLowerCase()
          .includes(filterCriteria.searchQuery.toLowerCase());

      return (
        matchesCountry &&
        matchesCity &&
        matchesGender &&
        matchesStatus &&
        matchesSearch
      );
    });

    setFilteredUser(filtered);
    dispatch(setSelectedUser(filtered?.length > 0 ? filtered[0] : {}));
  }, [filterCriteria, userList]);

  useEffect(() => {
    if (filterCriteria.country) {
      const selectedCountry = countries.find(
        (country) => country.name === filterCriteria.country
      );
      if (selectedCountry) {
        const allCities = City.getCitiesOfCountry(selectedCountry.isoCode);
        setCities(allCities);
      } else {
        setCities([]);
      }
    } else {
      setCities([]);
    }
  }, [filterCriteria.country, countries]);

  // new code of handleFilterChange
  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    // Reset city if country is changed
    if (name === "country") {
      setFilterCriteria((prev) => ({
        ...prev,
        country: value,
        city: "",
      }));
    } else {
      setFilterCriteria((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_right_header">
            <div class="ct_left_header_cnt">
              <div class="form-group">
                <label for="" class="mb-2 ct_fw_600">
                  Country
                </label>
                <select
                  name="country"
                  className="form-control ct_input ct_pointer_curser"
                  value={filterCriteria.country}
                  onChange={handleFilterChange}
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country.isoCode} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="" class="mb-2 ct_fw_600">
                  City
                </label>
                <select
                  name="city"
                  className="form-control ct_input ct_pointer_curser cy_min_w_city_133px"
                  value={filterCriteria.city}
                  onChange={handleFilterChange}
                  disabled={!filterCriteria.country}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city.name} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="" class="mb-2 ct_fw_600">
                  Gender
                </label>
                <select
                  name="gender"
                  className="form-control ct_input ct_pointer_curser"
                  value={filterCriteria.gender}
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  {genderOptions.map((gender) => (
                    <option key={gender.key} value={gender.key}>
                      {gender.key}
                    </option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="" class="mb-2 ct_fw_600">
                  Status
                </label>
                <select
                  name="status"
                  className="form-control ct_input ct_pointer_curser"
                  value={filterCriteria.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value={0}>Active</option>
                  <option value={1}>Block</option>
                </select>
              </div>
              {/* <SearchInput onSearch={handleSearch} /> */}
              <div className="form-group">
                <label htmlFor="" className="mb-2 ct_fw_600 ct_nbsp_none_1199">
                  &nbsp;
                </label>
                <div className="position-relative">
                  <i className="fa-solid fa-magnifying-glass ct_search_icon_12"></i>
                  <input
                    type="text"
                    className="form-control ct_input ct_text_indent_30"
                    placeholder="Search"
                    name="searchQuery"
                    value={filterCriteria.searchQuery}
                    onChange={handleFilterChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="ct_inner_dashbaord_main">
            <div class="row ">
              {/* all users */}
              <div class="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                <div class="ct_top_sticky">
                  <div class="">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_flex_col_575">
                      <ul class="d-flex align-items-center  gap-2 mb-0">
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            All Users
                          </h4>

                           
                        </li>
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            <i class="bi bi-dot"></i>
                          </h4>
                        </li>
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            {filteredUser?.length} {" "}{filteredUser?.length <= 1 ? "User" : "Users"}
                          </h4>
                        </li>
                      
                      </ul>
                         <button
    className="ct_orange_btn ct_pointer_curser"
    onClick={() => downloadCSV(filteredUser, "filtered-users.csv")}
    disabled={!filteredUser?.length}
  >
    <i className="fa-solid fa-download me-2"></i>
    Download CSV
  </button>
                    </div>
                    <UserTable data={filteredUser} filterCriteria={{ filterCriteria }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div
        class="modal fade ct_assets_modal"
        id="ct_user_img_preview"
        tabindex="-1"
        aria-labelledby="ct_user_img_previewLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header pb-0 border-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mt-0">
              <img src="./user_profile.png" alt="" class="ct_img_400_big" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
